function changeMainImage(imageSrc) {
    document.getElementById('mainImage').src = imageSrc;
}

function scrollCarousel(direction) {
    const carousel = document.querySelector('.mobile-carousel');
    if (!carousel) return; // Only work on mobile

    const imageWidth = window.innerWidth; // Full viewport width

    let currentScroll = carousel.scrollLeft;
    let targetScroll;

    if (direction === 1) {
        // Next
        targetScroll = currentScroll + imageWidth;
        if (targetScroll >= carousel.scrollWidth) {
            targetScroll = 0; // Loop to first image
        }
    } else {
        // Previous
        targetScroll = currentScroll - imageWidth;
        if (targetScroll < 0) {
            targetScroll = carousel.scrollWidth - imageWidth; // Loop to last image
        }
    }

    carousel.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
    });
}

// Debounce function to limit calculation frequency
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

// Debounced calculation functions
//const debouncedCalculateTotal = debounce(calculateTotal, 150);
// const debouncedCalculateFromArea = debounce(calculateFromArea, 150);

function updateAreaLabels() {
    const unitsSelect = document.getElementById('unitsSelect');
    const widthLabel = document.getElementById('widthLabel');
    const lengthLabel = document.getElementById('lengthLabel');
    const areaLabel = document.getElementById('areaLabel');

    if (unitsSelect.value === 'metres') {
        widthLabel.textContent = 'Width (m):';
        lengthLabel.textContent = 'Length (m):';
        if (areaLabel) areaLabel.textContent = 'Area (m²):';
    } else {
        widthLabel.textContent = 'Width (ft):';
        lengthLabel.textContent = 'Length (ft):';
        if (areaLabel) areaLabel.textContent = 'Area (ft²):';
    }

    // Trigger calculations immediately for unit changes
    calculateTotal();
    calculateFromArea();
}

function calculateTotal() {
    const width = parseFloat(document.getElementById('widthInput').value) || 0;
    const length = parseFloat(document.getElementById('lengthInput').value) || 0;
    const unitsSelect = document.getElementById('unitsSelect');
    // Check both desktop and mobile wastage checkboxes
    const wastageCheckbox = document.getElementById('wastageCheckbox');
    const wastageCheckboxMobile = document.getElementById('wastageCheckboxMobile');
    const wastageApplied = (wastageCheckbox && wastageCheckbox.checked) ||
                          (wastageCheckboxMobile && wastageCheckboxMobile.checked);

    let area = width * length;

    // Convert feet to metres if needed
    if (unitsSelect.value === 'feet') {
        area = area * 0.092903; // Convert square feet to square metres
    }

    // Add 5% wastage if checkbox is checked
    if (wastageApplied) {
        area = area * 1.05;
    }

    // Update area display (both desktop and mobile)
    document.getElementById('totalArea').textContent = area.toFixed(2);
    const totalAreaMobile = document.getElementById('totalAreaMobile');
    if (totalAreaMobile) {
        totalAreaMobile.textContent = area.toFixed(2);
    }

    // Calculate packs needed (each pack covers the metafield value)
    const packCoverage = parseFloat(window.packCoverage || '1.2');
    const packsNeeded = Math.ceil(area / packCoverage);
    document.getElementById('packsNeeded').textContent = packsNeeded + ' Packs';

    // Update mobile packs needed
    const packsNeededMobile = document.getElementById('packsNeededMobile');
    if (packsNeededMobile) {
        packsNeededMobile.textContent = packsNeeded + ' Packs';
    }

    // Auto-update quantity input to match packs needed
    const quantityInputs = document.querySelectorAll('.quantity-input');
    quantityInputs.forEach(input => {
        input.value = packsNeeded;
    });

    // Calculate total price using dynamic product price
    // Get the raw product price in cents and convert to currency units
    const rawProductPrice = window.productPrice; // This is in cents (e.g., 500 for £5.00)
    const pricePerPack = rawProductPrice / 100.0; // Convert cents to currency units
    const totalPrice = packsNeeded * pricePerPack;

    document.getElementById('totalPrice').textContent = '£' + totalPrice.toFixed(2);

    // Update mobile total price
    const totalPriceMobile = document.getElementById('totalPriceMobile');
    if (totalPriceMobile) {
        totalPriceMobile.textContent = '£' + totalPrice.toFixed(2);
    }

    // Update mobile payment info (3 payments) - always update since it's dynamic now
    const paymentAmount = totalPrice / 3;
    const paymentText = document.querySelector('.payment-text');
    if (paymentText) {
        // Extract the text before the price for desktop version
        const textBeforePrice = paymentText.textContent.replace(/Make 3 interest-free payments of £[\d.]+ with/, 'Make 3 interest-free payments of £');
        if (textBeforePrice !== paymentText.textContent) {
            paymentText.innerHTML = `Make 3 interest-free payments of £${paymentAmount.toFixed(2)} with`;
        }
    }

    // Update mobile payment text
    const mobilePaymentText = document.querySelector('.mobile-payment-text');
    if (mobilePaymentText) {
        mobilePaymentText.innerHTML = `Make 3 interest-free payments of £${paymentAmount.toFixed(2)} with <img src="${window.klarnaImageUrl}" alt="Payment provider" class="mobile-payment-image"> 18+, T&Cs apply. Credit subject to status.`;
    }

    // Clear area input when using width/length
    if (width > 0 || length > 0) {
        document.getElementById('areaInput').value = '';
    }
}

function calculateFromArea() {
    const area = parseFloat(document.getElementById('areaInput').value) || 0;
    const unitsSelect = document.getElementById('unitsSelect');
    // Check both desktop and mobile wastage checkboxes
    const wastageCheckbox = document.getElementById('wastageCheckbox');
    const wastageCheckboxMobile = document.getElementById('wastageCheckboxMobile');
    const wastageApplied = (wastageCheckbox && wastageCheckbox.checked) ||
                          (wastageCheckboxMobile && wastageCheckboxMobile.checked);

    let areaInMetres = area;

    // Convert feet to metres if needed
    if (unitsSelect.value === 'feet') {
        areaInMetres = area * 0.092903; // Convert square feet to square metres
    }

    // Add 5% wastage if checkbox is checked
    if (wastageApplied) {
        areaInMetres = areaInMetres * 1.05;
    }

    // Update area display (both desktop and mobile)
    document.getElementById('totalArea').textContent = areaInMetres.toFixed(2);
    const totalAreaMobile = document.getElementById('totalAreaMobile');
    if (totalAreaMobile) {
        totalAreaMobile.textContent = areaInMetres.toFixed(2);
    }

    // Calculate packs needed (each pack covers the metafield value)
    const packCoverage = parseFloat(window.packCoverage || '1.2');
    const packsNeeded = Math.ceil(areaInMetres / packCoverage);
    document.getElementById('packsNeeded').textContent = packsNeeded + ' Packs';

    // Update mobile packs needed
    const packsNeededMobile = document.getElementById('packsNeededMobile');
    if (packsNeededMobile) {
        packsNeededMobile.textContent = packsNeeded + ' Packs';
    }

    // Auto-update quantity input to match packs needed
    const quantityInputs = document.querySelectorAll('.quantity-input');
    quantityInputs.forEach(input => {
        input.value = packsNeeded;
    });

    // Calculate total price using dynamic product price
    // Get the raw product price in cents and convert to currency units
    const rawProductPrice = window.productPrice; // This is in cents (e.g., 500 for £5.00)
    const pricePerPack = rawProductPrice / 100.0; // Convert cents to currency units
    const totalPrice = packsNeeded * pricePerPack;


    document.getElementById('totalPrice').textContent = '£' + totalPrice.toFixed(2);

    // Update mobile total price
    const totalPriceMobile = document.getElementById('totalPriceMobile');
    if (totalPriceMobile) {
        totalPriceMobile.textContent = '£' + totalPrice.toFixed(2);
    }

    // Update mobile payment info (3 payments) - always update since it's dynamic now
    const paymentAmount = totalPrice / 3;
    const paymentText = document.querySelector('.payment-text');
    if (paymentText) {
        // Extract the text before the price for desktop version
        const textBeforePrice = paymentText.textContent.replace(/Make 3 interest-free payments of £[\d.]+ with/, 'Make 3 interest-free payments of £');
        if (textBeforePrice !== paymentText.textContent) {
            paymentText.innerHTML = `Make 3 interest-free payments of £${paymentAmount.toFixed(2)} with`;
        }
    }

    // Update mobile payment text
    const mobilePaymentText = document.querySelector('.mobile-payment-text');
    if (mobilePaymentText) {
        mobilePaymentText.innerHTML = `Make 3 interest-free payments of £${paymentAmount.toFixed(2)} with <img src="${window.klarnaImageUrl}" alt="Payment provider" class="mobile-payment-image"> 18+, T&Cs apply. Credit subject to status.`;
    }

    // Clear width and length inputs when using area
    document.getElementById('widthInput').value = '';
    document.getElementById('lengthInput').value = '';
}

function updatePricingFromQuantity(quantity) {
    // Get the raw product price in cents and convert to currency units
    const rawProductPrice = window.productPrice; // This is in cents (e.g., 500 for £5.00)
    const pricePerPack = rawProductPrice / 100.0; // Convert cents to currency units
    const totalPrice = quantity * pricePerPack;

    // Update desktop total price
    document.getElementById('totalPrice').textContent = '£' + totalPrice.toFixed(2);

    // Update mobile total price
    const totalPriceMobile = document.getElementById('totalPriceMobile');
    if (totalPriceMobile) {
        totalPriceMobile.textContent = '£' + totalPrice.toFixed(2);
    }

    // Update payment info (3 payments) - always update since it's dynamic now
    const paymentAmount = totalPrice / 3;
    const paymentText = document.querySelector('.payment-text');
    if (paymentText) {
        // Extract the text before the price for desktop version
        const textBeforePrice = paymentText.textContent.replace(/Make 3 interest-free payments of £[\d.]+ with/, 'Make 3 interest-free payments of £');
        if (textBeforePrice !== paymentText.textContent) {
            paymentText.innerHTML = `Make 3 interest-free payments of £${paymentAmount.toFixed(2)} with`;
        }
    }

    // Update mobile payment text
    const mobilePaymentText = document.querySelector('.mobile-payment-text');
    if (mobilePaymentText) {
        mobilePaymentText.innerHTML = `Make 3 interest-free payments of £${paymentAmount.toFixed(2)} with <img src="${window.klarnaImageUrl}" alt="Payment provider" class="mobile-payment-image"> 18+, T&Cs apply. Credit subject to status.`;
    }
}

function updateAreaFromQuantity(quantity) {
    // Calculate total area based on quantity and pack coverage
    const packCoverage = parseFloat(window.packCoverage || '1.2');
    const totalArea = quantity * packCoverage;
    
    // Update area display (both desktop and mobile)
    document.getElementById('totalArea').textContent = totalArea.toFixed(2);
    const totalAreaMobile = document.getElementById('totalAreaMobile');
    if (totalAreaMobile) {
        totalAreaMobile.textContent = totalArea.toFixed(2);
    }
    
    // Update packs needed display
    document.getElementById('packsNeeded').textContent = quantity + ' Packs';
    const packsNeededMobile = document.getElementById('packsNeededMobile');
    if (packsNeededMobile) {
        packsNeededMobile.textContent = quantity + ' Packs';
    }
    
    // Clear the area, width, and length inputs since we're calculating from quantity
    document.getElementById('areaInput').value = '';
    document.getElementById('widthInput').value = '';
    document.getElementById('lengthInput').value = '';
}


function addToCart() {
    const quantity = getCurrentQuantity();
    let bundleShown = false;

    // Check if underlay bundle is available
    if (typeof window.bundleData !== 'undefined') {
        // Bundle is available - don't add anything yet, just show bundle option
        showBundleOption(quantity);
        bundleShown = true;
    }

    // Check if adhesive bundle is available (LVT products)
    if (typeof window.adhesiveBundleData !== 'undefined' && typeof showAdhesiveOption === 'function') {
        showAdhesiveOption(quantity);
        bundleShown = true;
    }

    if (bundleShown) {
        return;
    }

    // No bundle available - add flooring directly
    addJustFlooring();
}

// Bundle Functions
function showBundleOption(flooringQuantity) {
    if (typeof window.bundleData === 'undefined') {
        return; // No bundle data available
    }
    
    const bundleContainer = document.getElementById('flooringBundle');
    if (!bundleContainer) {
        return; // Bundle component not found
    }
    
    // Calculate underlay quantity based on total area and selected underlay's pack coverage
    const totalArea = parseFloat(document.getElementById('totalArea').textContent) || 0;
    const currentUnderlayId = window.bundleData.underlayProductId;

    // Find underlay data by ID (handle string/number mismatch)
    const currentUnderlayData = window.bundleData.underlayOptions[currentUnderlayId] ||
                                 window.bundleData.underlayOptions[String(currentUnderlayId)];

    const packCoverage = currentUnderlayData ? currentUnderlayData.packCoverage : window.bundleData.underlayCoverageRatio;
    const underlayQuantity = Math.ceil(totalArea / packCoverage);

    // Update bundle quantities
    document.getElementById('bundleFlooringQuantity').textContent = flooringQuantity;
    document.getElementById('bundleUnderlayQuantity').textContent = underlayQuantity;
    
    // Get current selected underlay price (use bundle data as it's already updated)
    let currentUnderlayPrice = window.bundleData.underlayPrice;

    // Calculate pricing
    const flooringTotal = flooringQuantity * (window.bundleData.flooringPrice / 100);
    const underlayTotal = underlayQuantity * (currentUnderlayPrice / 100);
    const individualTotal = flooringTotal + underlayTotal;

    // Apply bundle discount only to underlay
    const discountPercentage = window.bundleData.bundleDiscountPercentage;
    const underlayDiscountAmount = Math.floor(underlayTotal * (discountPercentage / 100) * 100) / 100;
    const discountedUnderlayTotal = underlayTotal - underlayDiscountAmount;
    const bundleTotal = flooringTotal + discountedUnderlayTotal;

    // Update pricing display
    document.getElementById('bundleFlooringPrice').textContent = '£' + flooringTotal.toFixed(2);
    document.getElementById('bundleUnderlayPrice').textContent = '£' + underlayTotal.toFixed(2);
    document.getElementById('bundleIndividualTotal').textContent = '£' + individualTotal.toFixed(2);

    if (discountPercentage > 0) {
        document.getElementById('bundleUnderlayPriceDiscounted').textContent = '£' + discountedUnderlayTotal.toFixed(2);
        document.getElementById('bundleUnderlayPriceDiscounted').style.display = 'block';
        document.getElementById('bundleDiscount').textContent = '-£' + underlayDiscountAmount.toFixed(2);
        document.getElementById('bundleSavingsAmount').textContent = '£' + underlayDiscountAmount.toFixed(2);
    }

    document.getElementById('bundleTotal').textContent = '£' + bundleTotal.toFixed(2);

    // Show the bundle container
    bundleContainer.style.display = 'block';
    
    // Scroll to bundle (smooth scroll)
    bundleContainer.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'nearest' 
    });
}

function hideBundle() {
    const bundleContainer = document.getElementById('flooringBundle');
    if (bundleContainer) {
        bundleContainer.style.display = 'none';
    }
}

// Handle underlay dropdown toggle
function toggleUnderlayDropdown() {
    const dropdown = document.getElementById('underlayDropdown');
    const trigger = document.getElementById('underlaySelectorTrigger');
    
    if (!dropdown || !trigger) {
        return;
    }
    
    const isOpen = dropdown.style.display !== 'none';
    
    if (isOpen) {
        closeUnderlayDropdown();
    } else {
        openUnderlayDropdown();
    }
}

// Open underlay dropdown
function openUnderlayDropdown() {
    const dropdown = document.getElementById('underlayDropdown');
    const trigger = document.getElementById('underlaySelectorTrigger');
    
    if (dropdown && trigger) {
        dropdown.style.display = 'block';
        trigger.classList.add('open');
        
        // Close dropdown when clicking outside
        document.addEventListener('click', closeUnderlayDropdownOnOutsideClick);
    }
}

// Close underlay dropdown
function closeUnderlayDropdown() {
    const dropdown = document.getElementById('underlayDropdown');
    const trigger = document.getElementById('underlaySelectorTrigger');
    
    if (dropdown && trigger) {
        dropdown.style.display = 'none';
        trigger.classList.remove('open');
        
        // Remove outside click listener
        document.removeEventListener('click', closeUnderlayDropdownOnOutsideClick);
    }
}

// Close dropdown when clicking outside
function closeUnderlayDropdownOnOutsideClick(event) {
    const dropdown = document.getElementById('underlayDropdown');
    const trigger = document.getElementById('underlaySelectorTrigger');
    
    if (dropdown && trigger && !dropdown.contains(event.target) && !trigger.contains(event.target)) {
        closeUnderlayDropdown();
    }
}

// Handle underlay selection from dropdown option
function selectUnderlay(element) {
    const selectedUnderlayId = element.dataset.id;
    
    if (!window.bundleData || !window.bundleData.underlayOptions) {
        return;
    }
    
    const underlayData = window.bundleData.underlayOptions[selectedUnderlayId];
    
    if (!underlayData) {
        console.error('Underlay data not found for ID:', selectedUnderlayId);
        return;
    }
    
    // Update trigger display
    const selectorImage = document.getElementById('underlaySelectorImage');
    const selectorTitle = document.getElementById('underlaySelectorTitle');
    
    if (selectorImage) {
        selectorImage.src = underlayData.image;
        selectorImage.alt = underlayData.title;
    }
    
    if (selectorTitle) {
        selectorTitle.textContent = underlayData.title + (underlayData.recommended ? ' (Recommended)' : '');
    }
    
    // Update bundle image
    const underlayImage = document.getElementById('bundleUnderlayImage');
    if (underlayImage) {
        underlayImage.src = underlayData.image;
        underlayImage.alt = underlayData.title;
    }
    
    // Update underlay description
    const underlayDescription = document.querySelector('.bundle-item--underlay .bundle-item__description');
    if (underlayDescription) {
        // Check if this is the recommended underlay by comparing with original metafield underlay
        const isRecommended = window.bundleData.underlayOptions && 
                             window.bundleData.underlayOptions[selectedUnderlayId] && 
                             window.bundleData.underlayOptions[selectedUnderlayId].recommended;
        
        if (isRecommended) {
            underlayDescription.textContent = 'Recommended underlay';
        } else {
            underlayDescription.textContent = 'Selected underlay';
        }
    }
    
    // Update bundle data with new underlay selection
    window.bundleData.underlayProductId = underlayData.id;
    window.bundleData.underlayVariantId = underlayData.variantId;
    window.bundleData.underlayPrice = underlayData.price;
    window.bundleData.underlayProductTitle = underlayData.title;
    
    // Recalculate bundle pricing
    const flooringQuantity = parseInt(document.getElementById('bundleFlooringQuantity').textContent);
    const underlayQuantity = parseInt(document.getElementById('bundleUnderlayQuantity').textContent);

    const flooringTotal = flooringQuantity * (window.bundleData.flooringPrice / 100);
    const underlayTotal = underlayQuantity * (window.bundleData.underlayPrice / 100);
    const individualTotal = flooringTotal + underlayTotal;

    // Apply bundle discount only to underlay
    const discountPercentage = window.bundleData.bundleDiscountPercentage;
    const underlayDiscountAmount = Math.floor(underlayTotal * (discountPercentage / 100) * 100) / 100;
    const discountedUnderlayTotal = underlayTotal - underlayDiscountAmount;
    const bundleTotal = flooringTotal + discountedUnderlayTotal;

    // Update pricing display
    document.getElementById('bundleFlooringPrice').textContent = '£' + flooringTotal.toFixed(2);
    document.getElementById('bundleUnderlayPrice').textContent = '£' + underlayTotal.toFixed(2);
    document.getElementById('bundleIndividualTotal').textContent = '£' + individualTotal.toFixed(2);

    if (discountPercentage > 0) {
        document.getElementById('bundleUnderlayPriceDiscounted').textContent = '£' + discountedUnderlayTotal.toFixed(2);
        document.getElementById('bundleUnderlayPriceDiscounted').style.display = 'block';
        document.getElementById('bundleDiscount').textContent = '-£' + underlayDiscountAmount.toFixed(2);
        document.getElementById('bundleSavingsAmount').textContent = '£' + underlayDiscountAmount.toFixed(2);
    }

    document.getElementById('bundleTotal').textContent = '£' + bundleTotal.toFixed(2);

    // Close dropdown
    closeUnderlayDropdown();
}

// Helper function to get current quantity from inputs
function getCurrentQuantity() {
    const quantityInputs = document.querySelectorAll('.quantity-input');
    let quantity = 1;
    
    // Check if any input has focus (user just typed in it)
    const focusedInput = document.activeElement;
    if (focusedInput && focusedInput.classList.contains('quantity-input')) {
        quantity = focusedInput.value || 1;
    } else {
        // If no input is focused, use the first one with a value > 1, otherwise use the first one
        for (let input of quantityInputs) {
            if (input.value && parseInt(input.value) > 1) {
                quantity = input.value;
                break;
            }
        }
    }
    
    return parseInt(quantity);
}

function addJustFlooring() {
    // Hide bundle first
    hideBundle();
    
    const quantity = getCurrentQuantity();
    const variantId = window.productVariantId;
    
    // Show toast notification immediately
    showCartSuccessToast(quantity, window.productTitle);
    
    // Add to cart
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            id: variantId,
            quantity: quantity
        })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    })
    .then(data => {
        // Dispatch cart update event
        document.dispatchEvent(new CustomEvent('cart:update', { detail: data }));
        
        // Also dispatch cart:item-added event for flooring additions
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
    })
    .catch(error => {
        console.error('Error adding to cart:', error);
    });
}

function addBundleToCart() {
    if (typeof window.bundleData === 'undefined') {
        console.error('Bundle data not available');
        return;
    }
    
    const flooringQuantity = parseInt(document.getElementById('bundleFlooringQuantity').textContent);
    const underlayQuantity = parseInt(document.getElementById('bundleUnderlayQuantity').textContent);
    
    // Add complete bundle (both flooring and underlay)
    const bundleId = Date.now().toString();
    const items = [
        {
            id: window.bundleData.flooringVariantId,
            quantity: flooringQuantity,
            properties: {
                '_bundle': 'flooring-underlay',
                '_bundle_id': bundleId,
                '_bundle_type': 'flooring',
                '_bundle_category': 'flooring',
                '_bundle_discount': window.bundleData.bundleDiscountPercentage,
                '_bundle_total_discount': document.getElementById('bundleDiscount').textContent
            }
        },
        {
            id: window.bundleData.underlayVariantId,
            quantity: underlayQuantity,
            properties: {
                '_bundle': 'flooring-underlay',
                '_bundle_id': bundleId,
                '_bundle_type': 'underlay',
                '_bundle_category': 'flooring',
                '_bundle_discount': window.bundleData.bundleDiscountPercentage,
                '_bundle_total_discount': document.getElementById('bundleDiscount').textContent
            }
        }
    ];
    
    
    
    // Validate variant IDs
    if (!window.bundleData.flooringVariantId || !window.bundleData.underlayVariantId) {
        console.error('Invalid variant IDs:', {
            flooringVariantId: window.bundleData.flooringVariantId,
            underlayVariantId: window.bundleData.underlayVariantId
        });
        alert('Error: Invalid product configuration. Please contact support.');
        return;
    }
    
    // Show loading state
    const addButton = document.getElementById('addBundleToCart');
    const originalText = addButton.innerHTML;
    addButton.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/><path d="M12 6V12L16 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg> Adding...';
    addButton.disabled = true;
    
    // Add bundle to cart
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            items: items
        })
    })
    .then(response => {
        if (!response.ok) {
            // Try to get detailed error information
            return response.json().then(errorData => {
                const error = new Error(`HTTP error! status: ${response.status}`);
                error.status = response.status;
                error.data = errorData;
                throw error;
            }).catch(jsonError => {
                const error = new Error(`HTTP error! status: ${response.status}`);
                error.status = response.status;
                error.data = null;
                throw error;
            });
        }
        return response.json();
    })
    .then(data => {
        // Check if there's an actual error in the response
        // Shopify sometimes returns HTTP 200 but with error status in the JSON body (e.g., status: 422)
        if (data.status && (data.status === 'error' || (typeof data.status === 'number' && data.status >= 400))) {
            const error = new Error(data.message || data.description || 'Failed to add to cart');
            error.status = data.status;
            error.data = data;
            throw error;
        }

        return data;
    })
    .then(data => {
        // Show bundle success toast
        const flooringProduct = window.bundleData.flooringProductTitle || 'Flooring';
        const underlayProduct = window.bundleData.underlayProductTitle || 'Underlay';
        const bundleTotal = document.getElementById('bundleTotal').textContent;

        showCartSuccessToast(1, `Bundle: ${flooringProduct} + ${underlayProduct} (${bundleTotal})`);

        // Hide bundle
        hideBundle();

        // Dispatch cart update event
        document.dispatchEvent(new CustomEvent('cart:update', { detail: data }));

        // Also dispatch cart:item-added event for bundle additions
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
    })
    .catch(error => {
        let errorMessage = 'Sorry, there was an error adding the bundle to your cart. Please try again.';
        let errorTitle = 'Error';
        
        // Check if we have error data from the response
        if (error.data && error.data.errors) {
            const errors = error.data.errors;
            
            // Check for out of stock errors
            if (errors.quantity && errors.quantity.length > 0) {
                const quantityError = errors.quantity[0];
                if (quantityError.includes('not available') || quantityError.includes('out of stock')) {
                    errorTitle = 'Out of Stock';
                    
                    // Try to identify which product is out of stock
                    if (quantityError.includes('flooring') || quantityError.toLowerCase().includes(window.bundleData.flooringProductTitle.toLowerCase())) {
                        errorMessage = `${window.bundleData.flooringProductTitle} is currently out of stock.`;
                    } else if (quantityError.includes('underlay') || quantityError.toLowerCase().includes(window.bundleData.underlayProductTitle.toLowerCase())) {
                        errorMessage = `${window.bundleData.underlayProductTitle} is currently out of stock.`;
                    } else {
                        errorMessage = 'One or more items in this bundle are currently out of stock.';
                    }
                }
            }
            
            // Check for invalid variant errors
            else if (errors.items && errors.items.length > 0) {
                errorTitle = 'Invalid Product';
                errorMessage = 'One or more products in this bundle are no longer available.';
            }
            
            // Check for general validation errors
            else if (errors.variant_id) {
                errorTitle = 'Product Error';
                errorMessage = 'One or more products in this bundle are no longer available.';
            }
            
            // Check for other common errors
            else if (errors.description) {
                errorTitle = 'Product Error';
                errorMessage = errors.description[0] || 'One or more products in this bundle are no longer available.';
            }
            
            // Check for items array errors (common in Shopify)
            else if (Array.isArray(errors.items) && errors.items.length > 0) {
                const itemError = errors.items[0];
                if (itemError.quantity && itemError.quantity.length > 0) {
                    const quantityError = itemError.quantity[0];
                    if (quantityError.includes('not available') || quantityError.includes('out of stock')) {
                        errorTitle = 'Out of Stock';
                        errorMessage = 'One or more items in this bundle are currently out of stock.';
                    }
                }
            }
        } else if (error.data && error.data.description) {
            // Handle direct description errors
            errorTitle = 'Product Error';
            errorMessage = error.data.description;
        } else if (error.status === 422) {
            // Handle 422 errors specifically
            errorTitle = 'Product Error';
            errorMessage = 'One or more products in this bundle are no longer available or out of stock.';
        }
        
        // Create a more user-friendly error modal
        const errorModal = document.createElement('div');
        errorModal.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 10000;
        `;
        
        errorModal.innerHTML = `
            <div style="background: white; padding: 30px; border-radius: 10px; max-width: 400px; text-align: center;">
                <h3 style="margin: 0 0 15px 0; color: #333;">${errorTitle}</h3>
                <p style="margin: 0 0 20px 0; color: #666;">${errorMessage}</p>
                <button onclick="this.parentElement.parentElement.remove()" style="
                    background: #3D4E5F;
                    color: white;
                    border: none;
                    padding: 10px 20px;
                    border-radius: 5px;
                    cursor: pointer;
                ">OK</button>
            </div>
        `;
        
        document.body.appendChild(errorModal);
    })
    .finally(() => {
        // Reset button state
        addButton.innerHTML = originalText;
        addButton.disabled = false;
    });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
    calculateTotal();
    
    // Make quantity inputs more user-friendly
    const quantityInputs = document.querySelectorAll('.quantity-input');
    quantityInputs.forEach(input => {
        // Select all text when clicked
        input.addEventListener('click', function() {
            this.select();
        });
        
        // Allow Enter key to add to cart
        input.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                addToCart();
            }
        });
        
        // Update pricing on input (allow empty/invalid values while typing)
        input.addEventListener('input', function() {
            let value = parseInt(this.value);
            // Only update if we have a valid number, but don't force it to 1 while typing
            if (!isNaN(value) && value >= 1) {
                // Update pricing when quantity changes
                updatePricingFromQuantity(value);
                // Also update area display based on quantity
                updateAreaFromQuantity(value);
            }
        });
        
        // Validate input on blur and update pricing
        input.addEventListener('blur', function() {
            let value = parseInt(this.value);
            if (isNaN(value) || value < 1) {
                this.value = 1;
                value = 1;
            }
            // Update pricing when quantity changes
            updatePricingFromQuantity(value);
            // Also update area display based on quantity
            updateAreaFromQuantity(value);
        });
    });

    // Initialize lead time message text based on stock due date
    initializeLeadTimeMessage();
});

function initializeLeadTimeMessage() {
    // Initialize desktop lead time messages (there are multiple instances)
    const leadTimeTextMain = document.getElementById('leadTimeTextMain');
    if (leadTimeTextMain) {
        setLeadTimeMessageContent(leadTimeTextMain);
    }
    
    const leadTimeTextAccessories = document.getElementById('leadTimeTextAccessories');
    if (leadTimeTextAccessories) {
        setLeadTimeMessageContent(leadTimeTextAccessories);
    }

    // Initialize mobile lead time message
    const mobileLeadTimeText = document.getElementById('mobileLeadTimeText');
    if (mobileLeadTimeText) {
        setLeadTimeMessageContent(mobileLeadTimeText);
    }
}

function setLeadTimeMessageContent(element) {
    if (!element) {
        return;
    }
    
    const dueDate = element.dataset.dueDate;
    const formattedDate = element.dataset.formattedDate; // Pre-formatted date from Liquid
    const mainText = element.dataset.mainText;
    const noDateText = element.dataset.noDateText;
    const pastDateText = element.dataset.pastDateText;
    // Try accessing via dataset first, fallback to getAttribute if needed
    let stockEqualTo0Text = element.dataset.stockEqualTo0Text;
    if (!stockEqualTo0Text) {
        // Fallback: try getAttribute directly (for cases where dataset conversion fails)
        stockEqualTo0Text = element.getAttribute('data-stock-equal-to-0-text');
    }
    const discountedText = element.dataset.discountedText;
    const hasDiscountedTag = element.dataset.hasDiscountedTag === 'true';
    const productTitle = element.dataset.productTitle;
    
    // Get inventory quantity from window (set from product metafield)
    // Get original value first to check if it's 0 or negative
    const originalInventoryQuantity = window.inventoryQuantity || 0;
    const isStockZeroOrNegative = originalInventoryQuantity <= 0;
    
    // Ensure negative values are treated as 0 for display
    const inventoryQuantity = Math.max(0, originalInventoryQuantity);

    let messageHTML = '';

    // Priority 1: If stock is 0 or negative, use the "stock equal to 0" text
    if (isStockZeroOrNegative && stockEqualTo0Text && stockEqualTo0Text.trim() !== '') {
        messageHTML = formatMessageWithPlaceholders(stockEqualTo0Text, inventoryQuantity, formattedDate);
    } else if (hasDiscountedTag && discountedText && discountedText.trim() !== '') {
        // Priority 2: Show discounted text if product is discounted (regardless of date)
        messageHTML = formatMessageWithPlaceholders(discountedText, inventoryQuantity, formattedDate);
    } else if (dueDate && dueDate.trim() !== '') {
        // Parse the due date to check if it's in the past
        let dueDateObj;
        const dateStr = dueDate.trim();
        
        // Try to parse DD-MM-YYYY or DD/MM/YYYY format (handles both separators)
        if (dateStr.match(/^\d{2}[-\/]\d{2}[-\/]\d{4}$/)) {
            const parts = dateStr.split(/[-\/]/);
            const day = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1; // Month is 0-indexed
            const year = parseInt(parts[2], 10);
            dueDateObj = new Date(year, month, day);
        } else {
            // Try standard date parsing
            dueDateObj = new Date(dateStr);
        }
        
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset time to compare dates only
        dueDateObj.setHours(0, 0, 0, 0);

        if (dueDateObj < today || isNaN(dueDateObj.getTime())) {
            // Date is in the past or invalid
            if (pastDateText && pastDateText.trim() !== '') {
                messageHTML = formatMessageWithPlaceholders(pastDateText, inventoryQuantity, formattedDate);
            } else if (noDateText && noDateText.trim() !== '') {
                messageHTML = formatMessageWithPlaceholders(noDateText, inventoryQuantity, formattedDate);
            }
        } else {
            // Date is valid (today or future)
            if (mainText && mainText.trim() !== '') {
                // Use formatted date from Liquid or format it here as fallback
                const dateToUse = formattedDate || formatDateFallback(dueDateObj);
                
                // Replace placeholders in the message
                messageHTML = formatMessageWithPlaceholders(mainText, inventoryQuantity, dateToUse);
            }
        }
    } else {
        // No date provided
        if (noDateText && noDateText.trim() !== '') {
            messageHTML = formatMessageWithPlaceholders(noDateText, inventoryQuantity, formattedDate);
        }
    }

    if (messageHTML) {
        element.innerHTML = messageHTML;
    } else {
        console.warn('Lead time message HTML is empty', {
            dueDate: dueDate,
            mainText: mainText,
            noDateText: noDateText,
            pastDateText: pastDateText
        });
    }
}

// Fallback date formatter if Liquid formatting fails
function formatDateFallback(dateObj) {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return dateObj.toLocaleDateString('en-GB', options);
}

// Helper function to replace placeholders in messages
function formatMessageWithPlaceholders(message, inventoryQuantity, formattedDate) {
    if (!message) return '';
    
    // Ensure inventory quantity is never negative (display as 0)
    const displayQuantity = Math.max(0, inventoryQuantity);
    
    let formatted = message;
    
    // Replace [stock_units] with actual inventory quantity (wrapped in bold span, ensure non-negative)
    formatted = formatted.replace(/\[stock_units\]/gi, '<span class="lead-time-bold">' + displayQuantity + '</span>');
    
    // Replace [stock_due_date] with formatted date (wrapped in bold span)
    if (formattedDate) {
        formatted = formatted.replace(/\[stock_due_date\]/gi, '<span class="lead-time-bold">' + formattedDate + '</span>');
    }
    
    // Backwards compatibility: also support old placeholders
    formatted = formatted.replace(/\[number of in stock units\]/gi, '<span class="lead-time-bold">' + displayQuantity + '</span>');
    formatted = formatted.replace(/\[number\]/g, '<span class="lead-time-bold">' + displayQuantity + '</span>');
    formatted = formatted.replace(/\[insert date\]/gi, formattedDate ? '<span class="lead-time-bold">' + formattedDate + '</span>' : '');
    
    return formatted;
}